module.exports = __webpack_public_path__ + "img/wayfinder-mobile-map-en.aa39ca24.webp";